import { SearchFormPanel } from "@magicware/dashboard/Panel";
import DataList from "@magicware/data-lists/DataList";
import { FormStateApiContextProvider } from "@magicware/forms/components/FormStateApiContext";
import { useTranslation } from "react-i18next";
import { parameterThunks, setPage } from "../../redux/parameters/parametersReducer";
import { RootState } from "../../redux/types";
import EntityListItemMenuContext from "../entities/EntityListItemMenuContext";
import ParameterListItem from "./ParameterListItem";
import ParameterListMenuContext from "./ParameterListMenuContext";
import ParameterSearchForm from "./ParameterSearchForm";

export default function ParameterListPage() {
    const { t } = useTranslation();
    return (
        <FormStateApiContextProvider>
            <SearchFormPanel>
                <ParameterSearchForm />
            </SearchFormPanel>
            <ParameterListMenuContext>
                <EntityListItemMenuContext
                    deleteSnackTitle={t("parameter-deletion")}
                    deleteThunk={parameterThunks.delete}
                >
                    <DataList
                        dataSelector={(state: RootState) => state.parameters.list}
                        setPageActionCreator={setPage}
                        emptyList={t("no-parameters-message")}
                    >
                        {(id) => <ParameterListItem parameterId={id} />}
                    </DataList>
                </EntityListItemMenuContext>
            </ParameterListMenuContext>
        </FormStateApiContextProvider>
    );
}
